var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrid16(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 360,
    viewBox: "0 0 640 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1511_20512)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "#90A8ED"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M266.188 64.0703C266.037 68.9703 263.333 76.6875 261.875 80H287.688C286.771 78.8958 285.013 74.6703 284.562 66.0703C284 55.3203 280.562 52.3828 273.812 52.3828C267.062 52.3828 266.375 57.9453 266.188 64.0703Z",
    fill: "#E7E5E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M266.188 64.0703C266.037 68.9703 263.333 76.6875 261.875 80H287.688C286.771 78.8958 285.013 74.6703 284.562 66.0703C284 55.3203 280.562 52.3828 273.812 52.3828C267.062 52.3828 266.375 57.9453 266.188 64.0703Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M299.017 61.7319C293.925 62.1093 291.763 63.0673 291.763 63.0673C291.763 63.0673 285.485 71.2254 277.022 70.7086C271.175 75.1099 260.335 73.7338 260.335 73.7338C260.335 73.7338 252.54 78.5822 241.618 64.8093C240.003 62.7828 236.794 58.3235 235.05 55.8789C234.295 54.8164 233.068 54.1951 231.76 54.2009L228.604 54.2241V17.3125L286.625 17.4809C290.472 17.4809 292.332 23.0493 292.332 23.0493C299.685 22.9215 301.115 30.2377 301.115 30.2377C301.115 30.2377 307.567 29.4248 308.852 36.0441C310.008 42.0073 311.107 60.9306 299.017 61.7319Z",
    fill: "#FF7051",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M228.604 17.3172V64.9998H186.772V17.1953L228.604 17.3172Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M186.772 17.1927V72.0636H0.552939L0 16.9023L186.772 17.1927Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M228.604 54.2266H228.401",
    stroke: "#E2442F",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M301.115 30.2422C303.155 38.3654 303.888 57.1202 295.721 62.108Z",
    fill: "#FF7051"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M301.115 30.2422C303.155 38.3654 303.888 57.1202 295.721 62.108",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M292.333 23.0625C294.937 31.0348 295.721 57.8664 291.763 63.0806Z",
    fill: "#FF7051"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M292.333 23.0625C294.937 31.0348 295.721 57.8664 291.763 63.0806",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M267.827 17.4336C286.014 23.0542 281.87 64.2684 277.022 70.7194Z",
    fill: "#FF7051"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M267.827 17.4336C286.014 23.0542 281.87 64.2684 277.022 70.7194",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M249.355 46.1758C254.08 52.6906 267.827 70.1216 260.335 73.739Z",
    fill: "#FF7051"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M249.355 46.1758C254.08 52.6906 267.827 70.1216 260.335 73.739",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M260.003 33.5312C261.724 43.0654 259.62 61.408 259.62 61.408Z",
    fill: "#FF7051"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M260.003 33.5312C261.724 43.0654 259.62 61.408 259.62 61.408",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M316.6 123.297H230.796V226.036H316.6V123.297Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M308.607 132.863H238.788V218.386H308.607V132.863Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M248.611 139.858C249.122 141.31 248.39 142.895 247.169 143.33C245.949 143.76 244.542 142.936 244.025 141.484C243.513 140.032 244.17 138.801 245.356 138.273C246.617 137.71 248.099 138.407 248.611 139.858Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M257.016 163.123C257.527 164.575 256.795 166.16 255.574 166.595C254.354 167.025 252.947 166.2 252.43 164.749C251.918 163.297 252.575 162.066 253.761 161.538C255.016 160.975 256.504 161.677 257.016 163.123Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M251.383 173.347C251.802 174.537 251.203 175.838 250.198 176.192C249.198 176.546 248.041 175.867 247.617 174.677C247.198 173.486 247.739 172.476 248.71 172.04C249.744 171.582 250.959 172.157 251.383 173.347Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M263.712 140.742C263.485 142.403 262.09 143.593 260.805 143.419C259.521 143.245 258.666 141.753 258.893 140.092C259.12 138.431 260.282 137.549 261.578 137.613C262.95 137.676 263.938 139.082 263.712 140.742Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M281.12 140.844C280.975 139.172 282.073 137.703 283.364 137.593C284.654 137.482 285.822 138.742 285.968 140.415C286.113 142.087 285.171 143.202 283.893 143.428C282.533 143.666 281.265 142.517 281.12 140.844Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M243.618 151.566C242.903 150.05 243.426 148.291 244.594 147.739C245.768 147.187 247.297 147.971 248.012 149.487C248.727 151.002 248.233 152.373 247.111 153.029C245.925 153.726 244.333 153.081 243.618 151.566Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M257.928 152.187C256.766 150.979 256.708 149.15 257.644 148.25C258.579 147.356 260.277 147.606 261.439 148.819C262.602 150.033 262.567 151.485 261.712 152.46C260.8 153.499 259.091 153.395 257.928 152.187Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M271.378 152.824C270.477 151.413 270.78 149.602 271.872 148.911C272.965 148.214 274.581 148.801 275.482 150.212C276.383 151.622 276.063 153.045 275.034 153.835C273.942 154.677 272.279 154.241 271.378 152.824Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M274.128 165.444C273.227 164.033 273.401 162.302 274.36 161.693C275.319 161.083 276.825 161.739 277.726 163.15C278.627 164.561 278.411 165.914 277.516 166.622C276.563 167.372 275.029 166.855 274.128 165.444Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M278.592 176.614C277.575 175.889 277.261 174.582 277.807 173.816C278.353 173.055 279.615 173.02 280.632 173.746C281.649 174.472 281.835 175.523 281.364 176.336C280.859 177.195 279.603 177.34 278.592 176.614Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M253.493 189.668C252.662 188.559 252.877 186.979 253.825 186.271C254.772 185.563 256.219 185.882 257.056 186.991C257.893 188.1 257.644 189.349 256.754 190.138C255.807 190.969 254.325 190.777 253.493 189.668Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M255.702 201.672C255.807 200.15 256.934 198.977 258.039 199.059C259.143 199.134 259.951 200.435 259.841 201.956C259.73 203.477 258.789 204.354 257.684 204.383C256.504 204.412 255.592 203.199 255.702 201.672Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M267.903 190.678C266.659 190.445 265.828 189.278 266.025 188.239C266.217 187.199 267.385 186.549 268.629 186.781C269.873 187.014 270.483 187.983 270.373 189.034C270.257 190.149 269.146 190.91 267.903 190.678Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M299.79 191.213C298.482 190.969 297.662 189.477 297.918 188.107C298.174 186.736 299.441 185.819 300.749 186.063C302.057 186.307 302.655 187.549 302.487 188.937C302.307 190.406 301.092 191.457 299.79 191.213Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M274.04 187.414C274.581 186.038 276.098 185.335 277.249 185.783C278.394 186.23 278.888 187.71 278.353 189.086C277.813 190.463 276.569 190.956 275.389 190.602C274.128 190.23 273.5 188.796 274.04 187.414Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M276.215 202.756C276.342 200.741 277.604 199.173 278.836 199.249C280.062 199.324 280.958 201.02 280.83 203.035C280.702 205.049 279.644 206.222 278.412 206.286C277.098 206.356 276.087 204.771 276.215 202.756Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M298.546 202.108C299.18 200.401 300.784 199.408 301.935 199.832C303.091 200.256 303.516 201.992 302.882 203.699C302.249 205.406 300.941 206.12 299.749 205.813C298.482 205.487 297.918 203.821 298.546 202.108Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M285.445 176.858C284.712 175.935 284.805 174.64 285.544 174.054C286.282 173.467 287.467 173.746 288.2 174.663C288.932 175.587 288.799 176.614 288.113 177.259C287.386 177.944 286.177 177.781 285.445 176.858Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M286.723 165.648C286.729 163.976 287.805 162.611 288.938 162.617C290.071 162.623 290.99 163.982 290.984 165.654C290.978 167.326 290.071 168.354 288.938 168.464C287.741 168.586 286.718 167.326 286.723 165.648Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M299.726 164.624C299.732 163.137 300.714 161.924 301.755 161.93C302.795 161.936 303.632 163.143 303.632 164.63C303.626 166.116 302.795 167.028 301.76 167.126C300.656 167.231 299.72 166.116 299.726 164.624Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M288.909 152.11C288.909 151.048 290.188 149.225 291.618 149.219C293.053 149.213 294.291 151.048 294.291 152.087C294.291 153.759 293.152 154.793 291.722 154.909C290.205 155.043 288.909 153.788 288.909 152.11Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M251.662 137.383V144.322",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M252.877 147.246V154.185",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M243.85 160.156V167.095",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M244.054 171.191V178.13",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M256.725 171.191V178.13",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M261.718 172.242L262.148 178.612",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M267.42 171.367L267.426 177.76",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M243.845 184.555L243.856 190.948",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M244.042 198.516L244.054 204.903",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M263.154 198.551L263.171 206.291",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M267.955 197.977L267.966 206.059",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M272.018 197.125L272.035 206.293",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M248.913 184.555L248.925 191.935",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M262.479 185.602L262.491 192.349",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M272.111 172.816L272.215 177.926",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M282.73 185.141L281.911 192.062",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M288.182 183.984L288.374 190.952",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M285.421 198.219L285.613 205.192",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M290.223 197.984L289.798 204.946",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M294.274 198.773L293.855 205.735",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M292.914 185.117L293.106 192.085",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M293.007 172.594L293.111 177.703",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M302.917 172.258L303.022 177.368",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M298.337 172.086L298.441 178.612",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M247.588 160.562L247.884 167.495",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M262.352 159.887L262.311 166.825",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M268.827 160.555L268.78 167.493",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M282.091 161.465L282.05 168.404",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M295.983 161.188L295.936 168.777",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M267.443 147.246V154.185",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M255.499 137.383V144.322",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M268.385 137.383V144.322",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M272.779 137.383V144.322",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M277.58 137.383V144.322",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M279.749 147.328V154.267",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M285.026 147.582V154.521",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M298.203 147.582V154.521",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M302.597 147.586L302.993 154.513",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M296.256 137.383V144.322",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M250.599 198.551C250.599 198.551 246.716 201.233 247.809 203.701C249.117 206.657 252.064 204.409 252.191 202.801C252.389 200.299 249.901 198.905 249.901 198.905",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M291.809 137.555C291.809 137.555 287.927 140.237 289.019 142.705C290.327 145.66 293.274 143.413 293.402 141.805C293.6 139.302 291.112 137.909 291.112 137.909",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M303.179 142.804C304.62 142.804 305.788 141.826 305.788 140.621C305.788 139.415 304.62 138.438 303.179 138.438C301.737 138.438 300.569 139.415 300.569 140.621C300.569 141.826 301.737 142.804 303.179 142.804Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M375.091 247.515H160.046C156.93 234.642 146.91 232.482 146.91 232.482L147.927 230.258H386.937C374.696 234.171 375.091 247.515 375.091 247.515Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M391.709 232.476H132.192C131.152 232.476 130.309 231.634 130.309 230.595V227.913C130.309 226.873 131.152 226.031 132.192 226.031H391.709C392.749 226.031 393.592 226.873 393.592 227.913V230.595C393.592 231.634 392.749 232.476 391.709 232.476Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M219.409 279.441L219.066 316.545L218.903 333.755H171.996V279.441H219.409Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M171.996 279.441H0V343.231H171.996V279.441Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M193.729 329.284C195.909 329.284 197.676 327.518 197.676 325.341C197.676 323.164 195.909 321.398 193.729 321.398C191.55 321.398 189.783 323.164 189.783 325.341C189.783 327.518 191.55 329.284 193.729 329.284Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M364.041 80H164.277C154.39 80 146.381 88.0071 146.381 97.8781V181.055H381.938V97.8781C381.938 88.0071 373.923 80 364.041 80Z",
    fill: "#E7E5E4"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M364.041 80H164.277C154.39 80 146.381 88.0071 146.381 97.8781V181.055H381.938V97.8781C381.938 88.0071 373.923 80 364.041 80Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M341.099 254.492C339.733 259.473 334.496 264.304 312.141 273.682C312.141 273.682 313.949 292.036 312.798 299.503C311.653 306.97 309.27 311.029 299.29 311.662C287.485 312.411 231.824 320.192 219.066 316.545L219.409 279.442C221.071 272.184 220.676 267.225 215.224 264.932C210.771 263.056 196.211 260.472 195.7 254.172C195.194 247.872 199.902 246.322 212.765 249.126C230.197 252.924 237.8 261.221 249.552 267.626C252.203 268.218 263.828 267.428 282.236 261.349C282.631 261.215 283.032 261.082 283.445 260.937C286.375 259.921 289.577 258.649 292.937 257.29C293.262 257.157 293.588 257.023 293.919 256.89C297.982 255.241 302.254 253.493 306.527 251.943C312.258 249.864 317.989 248.151 323.22 247.512C336.362 245.921 342.698 248.668 341.099 254.492Z",
    fill: "#FF7051",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M312.141 273.688C305.254 276.579 296.732 279.9 286.2 283.797",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M332.909 247.191C336.17 255.489 336.037 261.289 282.451 274.383",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M313.182 287.559C310.136 298.614 285.375 297.389 285.375 297.389",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M292.937 257.287C289.577 258.646 286.375 259.918 283.445 260.934C283.207 260.22 283.015 259.471 282.864 258.681C281.899 253.542 283.352 248.955 286.107 248.438C288.868 247.922 291.885 251.667 292.856 256.805C292.885 256.974 292.914 257.131 292.937 257.287Z",
    fill: "#FF7051",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M306.527 251.944C302.254 253.495 297.982 255.242 293.919 256.892C293.512 252.252 295.721 248.199 299.197 247.543C302.004 247.015 304.853 248.855 306.527 251.944Z",
    fill: "#FF7051",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M549.193 158.731H459.25L455.361 153.529L448.95 136.028L441.749 125.257L450.374 100.934C450.374 100.934 447.887 88.4674 458.529 85.0184C469.172 81.5694 479.379 78.9913 485.865 83.4216C492.294 87.8113 498.746 94.1113 501.362 107.304L647 107.24V158.731H549.193Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M389.314 38.3459L448.206 24.5091C448.991 24.3233 449.81 24.5497 450.392 25.1071C453.705 28.2949 464.783 39.7104 468.963 53.6168C474.868 73.2717 476.833 89.762 476.833 89.762C476.833 89.762 478.582 109.986 487.435 134.988L455.821 143.791L436.663 136.208L429.711 123.196L423.741 100.585C423.741 100.585 421.765 95.0052 420.132 92.0904C418.499 89.1755 416.33 84.211 411.576 79.9259C406.827 75.6407 403.183 71.2626 399.73 62.82C396.748 55.5388 391.755 44.942 388.518 40.4884C387.942 39.693 388.361 38.5723 389.314 38.3459Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M397.382 41.6053L445.405 30.0156C445.405 30.0156 460.587 39.4685 468.951 82.6685C471.619 96.4472 478.373 120.712 480.652 130.456L453.775 138.724L445.439 137.586L434.727 119.029L428.967 100.895C428.967 100.895 424.939 88.7421 422.829 84.1201C420.719 79.4982 416.761 75.1608 411.024 71.3169C406.455 68.2453 397.382 41.6053 397.382 41.6053Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M405.833 52.292L422.823 47.4727",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M420.428 51.7802C421.841 47.466 418.621 45.4628 415.854 46.1828C413.081 46.9028 414.959 52.7267 412.18 53.3131C408.629 54.068 406.757 50.4331 407.275 47.466",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M450.479 95.9074C436.622 98.3345 430.35 90.0835 428.949 82.9996C428.002 78.2209 432.786 75.7938 436.169 74.737C436.791 74.5396 437.366 74.3886 437.848 74.2783C438.941 74.0286 440.191 73.9706 441.394 74.1506C443.173 74.4177 444.864 75.2074 445.852 76.6938C446.247 77.2919 445.916 78.099 445.201 78.2093C444.428 78.3254 443.643 78.4183 442.853 78.4241C440.493 78.4357 438.133 77.6867 436.169 74.737C436.122 74.6615 436.07 74.5861 436.023 74.5106C432.606 69.128 436.791 63.6119 442.69 63.6119C448.59 63.6119 448.497 61.2196 449.688 57.8345C450.758 54.7977 455.123 52.8699 460.569 53.2009",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M442.853 78.4258L445.271 84.8361",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M446.84 91.0444C448.285 91.0444 449.456 89.5444 449.456 87.6941C449.456 85.8437 448.285 84.3438 446.84 84.3438C445.396 84.3438 444.225 85.8437 444.225 87.6941C444.225 89.5444 445.396 91.0444 446.84 91.0444Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M445.271 96.203C445.009 95.6804 444.858 95.0591 444.858 94.3972C444.858 92.5449 446.032 91.0469 447.474 91.0469C448.921 91.0469 450.089 92.5449 450.089 94.3972C450.089 94.9546 449.985 95.483 449.793 95.9475",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M465.719 68.6719C463.609 72.719 458.273 76.5861 453.914 73.1428C449.555 69.6996 447.113 67.8125 443.364 69.1538C439.615 70.4951 439.691 73.497 441.388 74.159",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M459.163 76.7422C461.575 79.3086 462.511 83.739 462.511 83.739",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M478.943 81.043C478.943 81.043 463.063 81.4436 454.891 86.5417C446.718 91.6397 449.915 104.455 450.572 112.183C451.229 119.911 454.362 125.979 459.494 123.627C464.627 121.282 466.132 117.606 467.51 110.824C468.887 104.042 467.847 98.4391 478.135 99.1823C482.802 99.7339 483.872 102.382 483.959 104.977C484.046 107.573 489.533 106.394 489.533 106.394L491.364 101.04L487.179 91.0475L478.943 81.043Z",
    fill: "#23A094"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M551.337 107.302H501.367C498.862 91.1197 485.464 81.1093 478.978 81.2197C472.316 81.33 458.041 82.8222 451.868 88.8029C447.09 93.4306 450.177 120.605 454.914 123.055C458.872 125.105 464.33 123.392 466.922 113.695C468.794 106.681 466.934 97.048 480.245 99.4751C488.19 100.921 479.117 124.652 500.827 127.526",
    fill: "#FFC900"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M551.337 107.302H501.367C498.862 91.1197 485.464 81.1093 478.978 81.2197C472.316 81.33 458.041 82.8222 451.868 88.8029C447.09 93.4306 450.177 120.605 454.914 123.055C458.872 125.105 464.33 123.392 466.922 113.695C468.794 106.681 466.934 97.048 480.245 99.4751C488.19 100.921 479.117 124.652 500.827 127.526",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M451.025 107.167C451.432 112.614 440.656 114.652 427.827 115.145C414.883 115.639 401.136 117.073 402.88 107.045C404.019 100.478 415.685 98.9453 428.525 98.9453C441.365 98.9453 450.636 101.965 451.025 107.167Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M453.78 124.837C453.786 130.545 444.23 132.937 431.396 133.251C418.44 133.57 408.059 133.709 407.495 123.821C407.083 116.563 419.562 115.326 432.396 115.547C445.23 115.762 453.774 117.289 453.78 124.837Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M461.639 153.449C462.046 160.184 452.943 161.125 443.068 160.777C432.39 160.399 423.951 161.537 423.491 153.211C423.148 147.102 433.442 146.057 444.027 146.237C454.611 146.417 461.354 148.81 461.639 153.449Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M459.988 141.138C459.988 145.592 450.246 148.751 439.08 149.012C427.049 149.291 417.551 149.813 417.022 140.848C416.633 134.269 428.229 133.155 440.15 133.358C452.071 133.561 459.988 135.152 459.988 141.138Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M424.381 176.109H477.501C478.094 176.109 478.518 176.684 478.332 177.247C477.234 180.58 474.2 191.148 473.572 207.54C472.805 227.531 484.947 228.147 474.537 271.149C474.444 271.538 474.089 271.823 473.688 271.823H431.716C431.181 271.823 430.78 271.353 430.856 270.83C431.879 263.909 428.101 252.755 426.659 249.015C425.148 245.09 418.307 233.855 420.684 216.685C422.689 202.238 427.601 195.276 423.532 177.184C423.41 176.632 423.817 176.109 424.381 176.109Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M436.587 267.169C436.064 267.169 435.645 266.763 435.61 266.24C435.128 258.669 432.135 250.273 431.001 247.335C430.734 246.638 430.373 245.854 429.961 244.948C427.682 239.966 423.439 230.693 425.293 217.315C425.84 213.384 426.619 209.987 427.374 206.713C429.054 199.42 430.658 192.458 429.13 181.884C429.042 181.292 429.496 180.758 430.094 180.758H471.247C471.88 180.758 472.345 181.344 472.2 181.96C470.869 187.557 469.352 196.162 468.922 207.363C468.625 215.039 470.079 220.213 471.479 225.212C473.845 233.637 476.281 242.329 470.863 266.409C470.764 266.856 470.363 267.175 469.904 267.175H436.587V267.169Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M432.402 193.105H445.108",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M443.579 196.067C444.899 194.656 444.626 190.609 442.83 189.808C440.778 188.891 438.092 189.39 437.97 194.146C437.866 198.355 433.082 196.706 434.215 189.68",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M469.294 201.035C465.859 199.334 461.633 198.277 459.395 199.009C457.157 199.74 457.442 203.474 452.24 201.569C447.038 199.665 447.573 207.62 445.108 207.213C441.987 206.708 435.535 209.037 436.831 215.58C438.063 221.776 448.084 220.539 449.996 219.186C451.63 217.793 448.479 215.662 446.096 214.924C443.492 214.117 443.579 209.53 448.177 209.751C453.013 209.983 452.943 213.449 452.583 215.249C452.554 215.412 452.74 215.522 452.856 215.406C453.885 214.39 455.896 212.253 457.559 212.062C459.291 211.864 464.935 214.402 466.376 220.284C467.585 225.219 469.201 231.548 462.644 232.251C462.278 232.291 461.935 232.471 461.691 232.75C459.843 234.875 455.053 238.87 449.479 234.237C449.996 231.734 449.404 230.398 447.41 229.882C445.439 229.365 442.679 233.313 445.678 235.659C447.515 237.093 449.386 235.253 449.479 234.237",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M444.44 232.405C438.505 232.411 431.298 230.088 430.757 223.312C430.286 217.442 436.924 215.961 436.924 215.961",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M439.772 231.914C439.708 238.179 441.539 239.701 445.294 239.933C449.049 240.171 451.112 251.36 459.779 246.93C468.439 242.499 467.358 240.438 467.358 240.438",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M462.65 232.254C462.656 236.876 466.039 242.88 474.13 241.596",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M468.91 207.809C465.882 208.645 463.545 213.261 462.395 214.132",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M459.552 219.617C463.098 222.387 461.912 228.147 461.912 228.147",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M455.89 221.836C458.576 224.443 457.198 229.175 457.198 229.175",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M452.978 225.738C456.041 232.253 452.647 230.79 450.944 229.902C449.247 229.013 446.137 228.978 446.236 226.702C446.276 225.814 442.615 223.3 445.591 220.646C447.23 219.183 451.048 221.349 450.525 223.503C449.717 226.818 445.66 226.162 445.66 226.162",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M446.398 215.023V220.185",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M438.865 253.82C438.18 260.701 443.486 262.634 443.329 258.756C443.12 253.373 448.375 253.007 448.27 259.807",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M437.691 257.091L450.81 256.789",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M645 278.311V327.405C645 327.405 448.648 327.788 434.96 327.405C426.212 327.161 422.12 324.432 422.12 320.704C422.12 318.602 423.428 316.181 425.939 313.707C405.386 306.368 421.626 298.843 421.626 298.843C408.17 294.215 414.726 285.656 426.334 284.002C405.264 273.016 420.864 264.324 431.304 264.852C435.739 265.073 476.961 260.398 476.961 260.398C476.961 260.398 487.33 260.398 490.097 267.291C492.62 273.573 488.859 278.311 488.859 278.311H645Z",
    fill: "#FFC900"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M421.626 298.844C421.626 298.844 403.427 307.269 429.903 314.98Z",
    fill: "#FFC900"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M421.626 298.844C421.626 298.844 403.427 307.269 429.903 314.98",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M425.939 313.702C418.976 320.553 421.272 327.016 434.96 327.399C448.649 327.782 644.001 327.399 644.001 327.399V278.305H488.859C488.859 278.305 492.626 273.567 490.097 267.279C487.331 260.387 476.961 260.387 476.961 260.387C476.961 260.387 435.739 265.067 431.304 264.84C420.865 264.312 405.264 273.004 426.334 283.99C413.32 285.848 406.659 296.369 427.421 300.318",
    fill: "#FFC900"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M425.939 313.702C418.976 320.553 421.272 327.016 434.96 327.399C448.649 327.782 644.001 327.399 644.001 327.399V278.305H488.859C488.859 278.305 492.626 273.567 490.097 267.279C487.331 260.387 476.961 260.387 476.961 260.387C476.961 260.387 435.739 265.067 431.304 264.84C420.865 264.312 405.264 273.004 426.334 283.99C413.32 285.848 406.659 296.369 427.421 300.318",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M421.632 298.848C421.632 298.848 403.433 307.273 429.909 314.984Z",
    fill: "#FFC900"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M421.632 298.848C421.632 298.848 403.433 307.273 429.909 314.984",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1511_20512"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid16);
export default __webpack_public_path__ + "static/media/grid16.2c00ca9dcabd925305bb422376e57bca.svg";
export { ForwardRef as ReactComponent };